import { createApp } from 'vue';
import App from './App.vue';
import router from './router';//添加router


createApp(App).use(router).mount('#app');//添加.use(router)
